import { ToastService } from './../../../../../../core/toast.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SecondHandSupply } from '../../models/second-hand-supply';
import { DeleteSecondHandSupplyService } from '../../services/delete-second-hand-supply.service';

@Component({
  selector: 'app-delete',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.scss']
})
export class DeleteComponent implements OnInit {

/* --------------------------------- Fields --------------------------------- */

/* ------------------------------- Constructor ------------------------------ */

  constructor(
    private dialogRef: MatDialogRef<DeleteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SecondHandSupply,
    private deleteSecondHandSupplyService: DeleteSecondHandSupplyService,
    private toast: ToastService
  ) { }

/* ---------------------------- Life cycle hooks ---------------------------- */

  ngOnInit(): void {
  }

/* ------------------------------ Close Dialog ------------------------------ */

  closeDialog(status: string) {
    // this.dialogRef.close(status);
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this.dialogRef.close(status); }, 1000);
  }

 async delete(){
   try {
    await this.deleteSecondHandSupplyService.deleteSecondHandSupplyByPk(this.data.id);
    this.toast.openSnackBar("This product is deleted successfully");
      this.closeDialog('yes');
   }catch(error){
    this.toast.openSnackBar("Unable to send for approval");
   }
  }
}



